@if (!exportMode) {
<div class="projects__add-button">
  <button
    mat-flat-button
    (click)="createProject()"
  >
    <mat-icon>add</mat-icon>
    {{ 'projects.button.addProject' | translate }}
  </button>
</div>
}
<div class="projects__list">
  @if (projects.length === 0) {
    <p class="projects__empty-hint">{{ 'projects.emptyRequired' | translate }}</p>
  }
  @for (project of projects; track project.uuid) {
    <div
      class="projects__container"
      (click)="selectProject(project)"
      (keydown.enter)="selectProject(project)"
      (keydown.space)="$event.preventDefault(); selectProject(project)"
      tabindex="0"
      role="button"
      [attr.aria-expanded]="project === activeProject"
      [class.active]="project === activeProject"
      [class.projects__container--draft]="isDraftProject(project)"
    >
      @if (isDraftProject(project)) {
        <span class="projects__draft-badge">{{ 'project.draft.badge' | translate }}</span>
      } @else if (!canSaveDraft && project.hasDraft) {
        <span class="projects__draft-badge">{{ 'project.draft.lockedBadge' | translate }}</span>
      }
      @if (exportMode && isExportableProject(project)) {
        <mat-checkbox
          class="projects__export-checkbox"
          [checked]="selectedExportIds.includes(project.uuid)"
          [disabled]="!selectedExportIds.includes(project.uuid) && !canSelectProject()"
          (change)="toggleExportSelection(project.uuid, $event.checked)"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
        ></mat-checkbox>
      }
      <div class="projects__container-header">
        <p class="projects__date">
          {{ project?.beginn | date: "MM/yyyy" }} -
          @if (project?.ende) {
            {{ project.ende | date: "MM/yyyy" }}
          } @else {
            {{ 'projects.textPartOne' | translate }}
          }
        </p>
        @let errorCount = getProjectErrorCount(project);
        @if (errorCount > 0) {
          <lib-badge
            class="projects__error-badge"
            role="img"
            tabindex="0"
            [size]="'medium'"
            [text]="errorCount.toString()"
            [type]="'error'"
            matTooltipClass="info-tooltip--wide"
            matTooltipPosition="below"
            [matTooltip]="getProjectErrorHover(project)"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
            [attr.aria-label]="errorCount === 1
              ? ('projects.validationErrorAriaSingular' | translate)
              : ('projects.validationErrorAriaPlural' | translate: {count: errorCount})">
          </lib-badge>
        }
      </div>

      <p>{{ 'projects.textPartTwo' | translate }}{{ project?.stelle }}</p>
      <p>{{ 'projects.textPartThree' | translate }}{{ project?.projektname }}</p>
      <p>{{ 'projects.textPartFour' | translate }}{{ project?.kunde }}</p>
      @if (isDraftProject(project)) {
        <span class="projects__not-exported">{{
          (isExportableProject(project) ? 'project.draft.exportsReleased' : 'project.draft.notExported') | translate
        }}</span>
      }
    </div>
  }
</div>

<!-- NP20-824: Platzhalter für die Profilsuche — hier stehen die Treffer der nicht gerenderten Projekte. -->
<div #searchSlot>
  @if (activeProject) {
    <mat-divider></mat-divider>
    <!--
      NP20-893: Wechsel des aktiven Projekts loest hier ueber `track by uuid` einen
      kompletten Component-Recreate aus. Ohne das trug der Child-Instance-State
      (NgForm-Controls mit touched/dirty aus dem vorherigen Projekt, projectLocal
      aus dem alten Clone, editMode-Setter-Effekte) still ueber den Wechsel weg —
      Pflichtfeld-Fehler des neuen Projekts blieben unsichtbar.
    -->
    @for (p of [activeProject]; track p.uuid) {
      <app-project
        [projekt]="p"
        [isNewProject]="isNewProject"
        [isSaving]="isSaving"
        [failedSave]="failedSave"
        [canSaveDraft]="canSaveDraft"
        [resumeEdit]="p.uuid === resumeEditUuid"
        (changedProject)="changeProjectData($event)"
        (draftProject)="changeProjectData($event, true)"
        (taskSave)="saveTask($event)"
        (discardDraft)="openDiscardModal()"
        (deletedProject)="openModal()"
        (cancelEdit)="onCancelProject()"
        [exportMode]='exportMode'
        [twoPagerMode]='twoPagerMode'
        [remainingMethodSlots]="getRemainingMethodSlots(p?.uuid)"
        [initialTaskIds]="taskSelections[p?.uuid] ?? null"
        [initialMethodIds]="methodSelections[p?.uuid] ?? null"
        [selectedSkillIds]="selectedSkillIds"
        [skillBudgetReached]="skillBudgetReached"
        (exportSelectionChange)="onTaskExportSelectionChange($event, p?.uuid)"
        (methodSelectionChange)="onProjectMethodSelectionChange($event, p?.uuid)"
        (skillSelectionChange)="skillSelectionChange.emit($event)"
      ></app-project>
    }
  }
</div>

<app-modal
  modalId="projectModal"
  [title]="'projects.modal.headline'"
  [text]="deleteHitsReleasedVersion ? 'projects.modal.textWithDraft' : 'projects.modal.text'"
  [(visible)]="showModal"
  [showButtons]="true"
  (save)="deleteProject()"
  [showClose]="true"
  [saveText]="'general.delete'"
></app-modal>

<app-modal
  modalId="discardDraftModal"
  [title]="'projects.modal.discardTitle'"
  [text]="'projects.modal.discardText'"
  [(visible)]="showDiscardModal"
  [showButtons]="true"
  (save)="discardActiveDraft()"
  [showClose]="true"
  [saveText]="'project.draft.discard'"
></app-modal>
